import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
    Box, Button,
    Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText,
    CircularProgress, Typography, Paper,
} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

const Help = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (e) => {
        e.stopPropagation()
        if (props.url)
            setOpen(true);
        else
            alert('준비중입니다')

    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box >
            {props.type == 'button' &&
                <Button variant="outlined" startIcon={<HelpOutlineIcon/> }
                onClick={handleClickOpen}
                >
                    Help - {props.title}
                </Button>
            }

            {!props.type &&
                <HelpOutlineIcon onClick={handleClickOpen}/>
            }
            
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth={'lg'}
                fullWidth={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{props.url}</DialogTitle>
                <DialogContent>
                    <iframe frameBorder='0' width="100%" height="700px" src={props.url} />
                </DialogContent>
                <DialogTitle id="alert-dialog-title">{"Is this guide is helpful?"}</DialogTitle>
                <DialogActions>
                    <Button startIcon={<ThumbUpIcon />} onClick={handleClose} color="primary">
                        Good
                    </Button>
                    <Button startIcon={<ThumbDownIcon />} onClick={handleClose} color="primary" autoFocus>
                        Bad
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
};


export default Help;